import { HEADING_CLASS_NAME } from "../const";
import { HeadingTypographyProps } from "../type";

/**
 * Figma:https://www.figma.com/file/6bx1Rw0vJT7mLdFIl7jitZ/Admin_Component?type=design&node-id=348%3A302&mode=dev
 */
export const Heading = ({ children, type }: HeadingTypographyProps) => {
  const headingClassName = HEADING_CLASS_NAME({ type });

  switch (type) {
    case "h1":
      return <h1 className={headingClassName}>{children}</h1>;
    case "h2":
      return <h2 className={headingClassName}>{children}</h2>;
    case "h3":
    default:
      return <h3 className={headingClassName}>{children}</h3>;
  }
};
